import React, { useImperativeHandle, forwardRef } from 'react';
import {
  ExtraFieldsAreaContent,
  Props as ExtraFieldsAreaContentProps,
} from './ExtraFieldsAreaContent';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { FormContext } from 'react-hook-form-legacy';
import { useExtraFieldsFormSimple } from './useExtraFieldsFormSimple';
import { useExtraFieldsFormValidation } from '../useExtraFieldsFormValidation';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import { ExtraFieldInternalValue } from '../extraFieldInternalValue';

type Props = ExtraFieldsAreaContentProps & {
  onChange: (
    extraFields: ExtraFieldInternalValue[],
    recordTypeName: string | undefined,
  ) => void;
  values?: readonly ExtraFieldInternalValue[];
  recordTypeName: string | null; // null means no recordType
};

export type ExtraFieldsAreaContentSimpleRef = {
  triggerValidation: () => Promise<boolean>;
};

export const ExtraFieldsAreaContentSimple = forwardRef<
  ExtraFieldsAreaContentSimpleRef,
  Props
>(({ onChange, values = [], recordTypeName, ...restProps }, ref) => {
  const { applyExtraFieldsValidationSchema } = useExtraFieldsFormValidation({
    extraFieldFormInfos: restProps.formFields,
    contextParams: restProps.contextParams ?? [],
  });

  const validationSchema = applyExtraFieldsValidationSchema(yup.object<any>());

  const { formMethods } = useExtraFieldsFormSimple({
    values,
    recordTypeName,
    availableRecordTypes: restProps.availableRecordTypes,
    onChange,
    validationSchema,
  });

  const { triggerValidation } = formMethods;

  useImperativeHandle(
    ref,
    () => ({
      triggerValidation,
    }),
    [triggerValidation],
  );

  return (
    <FormContext {...formMethods}>
      <ExtraFieldsAreaContent {...restProps} />
    </FormContext>
  );
});
